module.exports = __webpack_public_path__ + "img/notshared.90ed4ff4.svg";